import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from "@azure/msal-react";
import { loginRequest } from "./msal/authConfig";
import { InteractionStatus } from "@azure/msal-browser";
import AppMs from "./AppMs";
import NotificationCheck from "./NotificationCheck";
import { M365Provider } from "./m365Context";

function MainContent() {
   /**
    * useMsal is hook that returns the PublicClientApplication instance,
    * that tells you what msal is currently doing. For more, visit:
    * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
    */
   const { instance, inProgress } = useMsal();

   const activeAccount = instance.getActiveAccount();

   async function getMsGraph(token, graphEndpoint) {
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      // Add additional fields here

      return fetch(graphEndpoint, {
         method: "Get",
         headers,
      }).then((response) => response.json());
   }

   async function postMsGraph(token, data, graphEndpoint) {
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-type", "application/json");

      return fetch(graphEndpoint, {
         method: "Post",
         headers,
         body: JSON.stringify(data),
      })
         .then((response) => response.json())
         .catch((err) => {
            console.log(err);
         });
   }

   async function patchMsGraph(token, data, graphEndpoint) {
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-type", "application/json");
      headers.append("method", "PATCH");
      return fetch(graphEndpoint, {
         method: "PATCH",
         headers,
         body: JSON.stringify(data),
      }).then((response) => response.json());
   }

   async function getSiteDriveId(siteRelativePath) {
      console.log(siteRelativePath);
      
   // siteRelativePath z.B. "sites/Bender"
   const msRequest = {
      scopes: [],
   };
   const tokenResponse = await instance
      .acquireTokenSilent(msRequest)
      .then((respo) => respo)
      .catch((err) => {
         console.log("errorsilenttoken:");
         console.error(err);
         return instance.acquireTokenPopup(msRequest).catch((err) => console.log(err));
      });

   // 1. Site-ID holen 
   const siteEndpoint = `https://graph.microsoft.com/v1.0/sites/langenkampimmobilien.sharepoint.com:/${siteRelativePath}`;
   console.log(siteEndpoint);
   
   const site = await getMsGraph(tokenResponse.accessToken, siteEndpoint);

   if (site.error) {
      console.log("Error: getSiteDriveId (site):", site.error);
      return null;
   }

   // 2. Drives der Site abfragen
   const drivesEndpoint = `https://graph.microsoft.com/v1.0/sites/${site.id}/drives`;
   const drives = await getMsGraph(tokenResponse.accessToken, drivesEndpoint);

   if (drives.error) {
      console.log("Error: getSiteDriveId (drives):", drives.error);
      return null;
   }

   console.log("Site ID:", site.id);
   console.log("Drives:", drives.value);

   return drives.value; // Array mit {id, name, webUrl, ...}
}

   async function getMsSharepointData(myFolderName,myDriveId) {
      if (myFolderName) {
         const msRequest = {
            scopes: [],
         };
         let responseArray = [];
         const tokenResponse = await instance
            .acquireTokenSilent(msRequest)
            .then((respo) => {
               return respo;
            })
            .catch((err) => {
               console.log("errorsilenttoken:");
               console.error(err);
               const popupToken = instance
                  .acquireTokenPopup(msRequest)
                  .then((respo) => {
                     return respo;
                  })
                  .catch((err) => {
                     console.log(err);
                  });

               return popupToken;
               // handleLogoutRedirect();
            });

            let graphEndpoint =
            `https://graph.microsoft.com/v1.0/drives/${myDriveId}/root:/${myFolderName}:/children?$expand=thumbnails` //get all files in folder
         /* let graphEndpoint =
            "https://graph.microsoft.com/v1.0/drives/b!EhEjbZqX-k-9jBNIW-jPYLQgpHJ54z1Hkv6Ql9NddPQbBRk5Qc3GSqcHCrljXD2i/root:/" +
            myFolderName +
            ":/children?$expand=thumbnails"; //get all files in folder */
         /*
     "https://graph.microsoft.com/v1.0/sites/baurimmo.sharepoint.com,6d231112-979a-4ffa-bd8c-13485be8cf60";
     "https://graph.microsoft.com/v1.0/sites/6d231112-979a-4ffa-bd8c-13485be8cf60/drives"; //get all drives
      "https://graph.microsoft.com/v1.0/drive/b!EhEjbZqX-k-9jBNIW-jPYLQgpHJ54z1Hkv6Ql9NddPQbBRk5Qc3GSqcHCrljXD2i";
     */
         const mainFolderResponse = await getMsGraph(tokenResponse.accessToken, graphEndpoint)
            .then((data) => {
               // console.log(data);
               return data.value;
            })
            .catch((err) => {
               console.log("Error: getMsSharepointData:");
               console.error(err);
            });

         for await (const item of mainFolderResponse) {
            responseArray.push(item);
            if (item.folder) {
               graphEndpoint =
            `https://graph.microsoft.com/v1.0/drives/${myDriveId}/root:/${myFolderName}:/children?$expand=thumbnails`

               /* graphEndpoint =
                  "https://graph.microsoft.com/v1.0/drives/b!EhEjbZqX-k-9jBNIW-jPYLQgpHJ54z1Hkv6Ql9NddPQbBRk5Qc3GSqcHCrljXD2i/root:/" +
                  myFolderName +
                  "/" +
                  item.name +
                  ":/children?$expand=thumbnails"; //get all files in folder */

               let subFolderResponse = await getMsGraph(tokenResponse.accessToken, graphEndpoint)
                  .then((data) => {
                     return data.value.map((item2) => ({
                        ...item2,
                        parentFolder: item.name,
                     }));
                  })
                  .catch((err) => {
                     console.log("Error: getMsSharepointData:");
                     console.error(err);
                  });

               responseArray.push(...subFolderResponse);

               // --------------------------------------------------------
            }
         }
         return responseArray;
      }
   }

   async function postMsSharepointNewFolder(myFolderName,myDriveId) {
      if (myFolderName) {
         const subfolders = ["360", "Bewertungsmappe", "Bilder", "Grundrisse", "Notartermin"];
         let responseData;
         let graphEndpoint =
            `https://graph.microsoft.com/v1.0/drives/${myDriveId}/root/children`
         /* let graphEndpoint =
            "https://graph.microsoft.com/v1.0/drives/b!EhEjbZqX-k-9jBNIW-jPYLQgpHJ54z1Hkv6Ql9NddPQbBRk5Qc3GSqcHCrljXD2i/root/children"; */
         let folderdata = {
            name: myFolderName,
            folder: {},
            "@microsoft.graph.conflictBehavior": "fail",
            // "@microsoft.graph.conflictBehavior": "rename",
         };
         const tokenResponse = await instance.acquireTokenSilent({}).then((respo) => {
            return respo;
         });
         responseData = await postMsGraph(tokenResponse.accessToken, folderdata, graphEndpoint).then((data) => {
            return data;
         });

         if (responseData.error) {
            if (responseData.error.code === "nameAlreadyExists") {
               const errorHandleTokenResponse = await instance.acquireTokenSilent({}).then((respo) => {
                  return respo;
               });

               const folderPath = graphEndpoint.slice(0, -9) + ":/" + myFolderName;
               responseData = await getMsGraph(errorHandleTokenResponse.accessToken, folderPath).then((data) => {
                  return data;
               });
            }
         } else {
            console.log(responseData);
         }
         return responseData;
      }
   }

   async function updateMsSharepointNewFolder(myFolderId, myFolderName,myDriveId) {
      if (myFolderName) {
         let graphEndpoint =
            `https://graph.microsoft.com/v1.0/drives/${myDriveId}/items/${myFolderId}`
         /* let graphEndpoint =
            "https://graph.microsoft.com/v1.0/drives/b!EhEjbZqX-k-9jBNIW-jPYLQgpHJ54z1Hkv6Ql9NddPQbBRk5Qc3GSqcHCrljXD2i/items/" +
            myFolderId; */
         let folderdata = {
            name: myFolderName,
            folder: {},
            "@microsoft.graph.conflictBehavior": "rename",
         };
         const tokenResponse = await instance.acquireTokenSilent({}).then((respo) => {
            return respo;
         });
         const graphResponse = await patchMsGraph(tokenResponse.accessToken, folderdata, graphEndpoint).then((data) => {
            return data;
         });
         return graphResponse;
      }
   }


   async function postMsSharelink(itemId, driveId) {
      //"https://graph.microsoft.com/v1.0/drives/b!EhEjbZqX-k-9jBNIW-jPYLQgpHJ54z1Hkv6Ql9NddPQbBRk5Qc3GSqcHCrljXD2i/items/"
      if (itemId && driveId) {
         let graphEndpoint = "https://graph.microsoft.com/v1.0/drives/" + driveId + "/items/" + itemId + "/createLink";

         let linkoptions = {
            type: "view",
            scope: "anonymous",
            retainInheritedPermissions: true,
         };
         console.log(graphEndpoint);

         const tokenResponse = await instance.acquireTokenSilent({}).then((respo) => {
            return respo;
         });
         const graphResponse = await postMsGraph(tokenResponse.accessToken, linkoptions, graphEndpoint).then((data) => {
            return data;
         });
         return graphResponse;
      }
   }
   /* const handleRedirect = () => {
      instance
         .loginRedirect({
            ...loginRequest,
            prompt: "create",
         })
         .catch((error) => {
            console.log(error);
         });
   }; */

   const handleRedirect = () => {
   if (inProgress !== InteractionStatus.None) {
      console.log("Interaction already in progress, skipping loginRedirect");
      return;
   }

   instance
      .loginRedirect({
         ...loginRequest,
         prompt: "create",
      })
      .catch((error) => {
         console.log(error);
      });
};

   const handleLogoutRedirect = () => {
      instance.logoutRedirect().catch((error) => console.log(error));
   };


   return (
      <div className="App">
         <NotificationCheck />
         <AppMs
         getSiteDriveId={getSiteDriveId}
            activeAccount={activeAccount}
            postMsSharelink={postMsSharelink}
            getMsSharepointData={getMsSharepointData}
            postMsSharepointNewFolder={postMsSharepointNewFolder}
            updateMsSharepointNewFolder={updateMsSharepointNewFolder}
            handleLogoutRedirect={handleLogoutRedirect}
            handleRedirect={handleRedirect}
         />
      </div>
   );
}

export default function App({ msalInstance }) {
   return (
      <MsalProvider instance={msalInstance}>
         <M365Provider>
            <MainContent />
         </M365Provider>
      </MsalProvider>
   );
}
